import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorType } from 'src/app/core/routing/error-types';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from 'src/app/base/shared/syncfusion/adaptor-service.interface';
import { ToastService } from 'src/app/base/services/toast.service';
import {
  FilterDTO,
  IPagedResultDTOOfSignalDefinitionConfigDTO,
  SignalClient,
  SortDirection,
} from 'src/app/base/models/models.swagger.generated';

/**
 * Read-only lookup over the signal catalog, backing the signal picker in the sampling-profile editor.
 * Uses the dedicated JSON search endpoint rather than `GET /api/signals`, which serves collectors the
 * whole catalog plus every protocol mapping in one protobuf payload.
 */
@Injectable()
export class SignalCatalogLookupService extends ShowInactiveService implements IAdaptorService {

  constructor(
    private signalClient: SignalClient,
    private toastService: ToastService,
  ) {
    super();
  }

  public getData(
    skip: number,
    take: number,
    filters: FilterDTO[],
    sortBy: string | undefined,
    sortDirection: SortDirection | undefined,
  ): Observable<IPagedResultDTOOfSignalDefinitionConfigDTO | null> {
    return this.signalClient.searchSignalDefinitions(filters, skip, take, sortBy, sortDirection)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', '', ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

  public addRecord(): Observable<any> {
    return throwError(() => new Error('Not supported: the signal catalog is read-only.'));
  }

  public updateRecord(): Observable<any> {
    return throwError(() => new Error('Not supported: the signal catalog is read-only.'));
  }

  public deleteRecord(): Observable<any> {
    return throwError(() => new Error('Not supported: the signal catalog is read-only.'));
  }
}
